import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

export interface CriancaOption {
  id: number;
  nome: string;
  creche_id: number;
}

export function useCriancas() {
  const [criancas, setCriancas] = useState<CriancaOption[]>([]);

  const carregarCriancas = useCallback(async () => {
    try {
      const { data } = await api.get<CriancaOption[]>('/alunos');
      setCriancas(data || []);
    } catch {
      setCriancas([]);
    }
  }, []);

  useEffect(() => {
    carregarCriancas();
  }, [carregarCriancas]);

  return { criancas, carregarCriancas };
}
